import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Body2, Heading5 } from "app/popleads/components/ui-kit/Text";
import { colors } from "app/popleads/components/ui-kit/colors";
import { toAbsoluteUrl } from "_metronic/_helpers";
import SVG from "react-inlinesvg";
import Card from "app/popleads/components/ui-kit/Card";
import ExtensionInputGroup, { StyledLabel } from "./ExtensionInputGroup";
import FeatherIcon from "feather-icons-react";
import { useExtensionContext } from "../ExtensionContext";
import moment from "moment";
import Label from "app/popleads/components/ui-kit/Label";
import { getDynamicValue, nameTag } from "app/popleads/app/functions/util";
import Modal from "app/popleads/components/ui-kit/Modal";
import Options from "app/popleads/components/ui-kit/Options";
import {
    DEAL_CANCELLED,
    DEAL_LOST,
    DEAL_WON,
    POPUP_CONTENTS,
    statusOptions,
    isCipdCampaign,
    getCancellationReasonError,
} from "../utils/constants";
import ExtensionCancellationReasonFields from "./ExtensionCancellationReasonFields";
import useDealCancellationReasons from "app/popleads/hooks/useDealCancellationReasons";
import CustomDatePicker from "app/popleads/components/ui-kit/DateInput";
import { FormattedMessage, FormattedNumber } from "react-intl";
import ExtensionActivities from "./ExtensionActivities";
import ExtensionDealPayment from "./ExtensionDealPayment";
import ExtensionDealExEdCampaigns from "./ExtensionDealExEdCampaigns";
import useOlanakDurumDegistir from "app/popleads/hooks/useOlanakDurumDegistir";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { DealLabelWrapper, StyledResultItem } from "./ExtensionNewDealPage";
import { Avatar, AvatarSvg, Info, Name, ResultText } from "./ExtensionSearch";
import { ProfileLoadingOverlay } from "../ExtensionHome";
import Spinner from "app/popleads/components/ui-kit/Spinner";
import ExtensionDealAttachments from "./ExtensionDealAttachments";
import MaterialIcon from "app/popleads/components/ui-kit/MaterialIcon";

//todo : #00856A rengi yok onun yerine paid amounnta success kullandım
//todo: Activities Payment başlıklarında heading4 kullanıldı fakat düzeltilmeli
//todo: #00856C rengi olmadığı için right content farklı  TEKİN: #00856A olan success.900 kullanılabilir.
//not: exedlerde move yok. CIPD'de var.
//move butonu gösterme şartı: subdeal varsa ve tipi exed ise gösterme. diğer ihtimalde göster.
//cancel butonunun koşulu ise eski crmden atılan isteğe bakılarak yapılacak. koşul isteğin içinden gelecek. eğer o subdeala bağlı paid amount değeri varsa cancel görünmeyecek

const StyledContainer = styled("div")``;
export const StyledItemContainer = styled("div")`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${(props) => props.marginBottom || "16px"};
`;

export const StyledNameTag = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background-color: ${colors.l3rnTech[50]};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.l3rnTech[700]};
    font-weight: 500;
    font-size: 16px;
`;

const StyledDealTitle = styled(Heading5)`
    color: ${(props) => (props.isLink ? colors.l3rnTech[950] : colors.neutral[800])};
    margin-bottom: 4px;

    &:hover {
        text-decoration: ${(props) => (props.isLink ? "underline" : "none")};
    }
`;

const StyledDealContent = styled(Body2)`
    color: ${colors.neutral[800]};
`;

// const StyledRightContent = styled(Body2)`
//     color: ${colors.success[900]};
//     font-weight: 500;
// `;

const StyledPriceContent = styled(Body2)`
    color: ${colors.success[900]};
    font-weight: 500;
    font-size: 18px;
    white-space: nowrap;
`;

const StyledContentWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

const StyledLeftContent = styled.div`
    display: flex;
    flex-direction: column;
`;
const ViewDealTooltip = styled.div`
    width: 350px;
    height: max-content;
    max-height: 240px;
    overflow: auto;
    position: absolute;
    background: white;
    border: 1px solid ${colors.neutral[200]};
    border-radius: 4px;
    padding: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;

    top: 100%;
    right: 0;
`;

const ExtensionViewDeal = ({ wonDeals }) => {
    const { dealObject, setDealObject, selectedDeal, profile, setState } = useExtensionContext();
    const { olanakDurumDegistir } = useOlanakDurumDegistir();
    const [potentialValue, setPotentialValue] = useState(parseInt(selectedDeal?.durum?.replace("%", "")) || 75);
    const [statusValue, setStatusValue] = useState(selectedDeal?.durum);
    const [isLoading, setIsLoading] = useState(false);
    const [tooltipVisible, setTooltipVisible] = useState(false);

    const [isClosingDateModalOpen, setIsClosingDateModalOpen] = useState(false);
    const [isWonDealModalOpen, setIsWonDealModalOpen] = useState(false);
    const [isCancellationModalOpen, setIsCancellationModalOpen] = useState(false);
    const [cancellation, setCancellation] = useState({ cancellationReason: "", cancellationNote: "" });
    const [showDatePicker, setShowDatePicker] = useState(false);
    const courseNameLabel =
        selectedDeal?.dealCampaignType === "E-Learning"
            ? "E-Learning Bundles"
            : selectedDeal?.dealCampaignType === "Consulting"
            ? "Type of Consulting"
            : selectedDeal?.dealCampaignType === "Coaching"
            ? "Type of Coaching"
            : selectedDeal?.dealCampaignType === "In-house" ||
              selectedDeal?.dealCampaignType === "LVT In-House" ||
              selectedDeal?.dealCampaignType === "Learning Journey"
            ? "Course Name"
            : null;

    useEffect(() => {
        setPotentialValue(parseInt(selectedDeal?.durum?.replace("%", "")) || 75);
        setStatusValue(selectedDeal?.durum);
        setDealObject({ ...selectedDeal });
    }, [selectedDeal]);

    const user = useSelector((state) => state.auth.user);
    const cancellationReasonsConfig = useDealCancellationReasons();

    //
    /*useEffect(() => {
        // İlk render'da çalışmamasını sağla
        

        if (selectedDeal) {
            const { durum, campaign, kapanmaTarihi } = selectedDeal;
            const basTarih = campaign?.basTarih;
            const kapanisTarih = kapanmaTarihi;

            if (durum === DEAL_WON && basTarih !== kapanisTarih) {
                toast.warning("Won Deal status can be changed just to Cancelled");
                setIsClosingDateModalOpen(true);
                return;
            }

            /*olanakDurumDegistir({
                id: selectedDeal.id,
                profil: profile?.id,
                durum: potentialValue + "%",
                lastStatus: potentialValue + "%",
                kapanmaTarihi: selectedDeal.kapanmaTarihi,
            });
        }
    }, [potentialValue]);*/

    /*useEffect(() => {
        if (!isFirstRender.current) {
            // Fonksiyonel güncelleme kullan
            setDealObject((prevDealObject) => ({ ...prevDealObject, status: statusValue }));
        }
    }, [statusValue]);*/

    const handleClosingDateClick = () => {
        setShowDatePicker(true);
    };

    const handleDateChange = (date) => {
        setDealObject({ ...dealObject, closingDate: date });
        setShowDatePicker(false);
        setIsClosingDateModalOpen(false);
    };

    const dealProfileId = selectedDeal?.profilId || selectedDeal?.profil?.id || profile?.id;
    const selectedDealNationalIdNumber = selectedDeal?.nationalIdNumber || selectedDeal?.nationalIDNumber || "";

    const handleStatusChange = (value) => {
        if (value === statusValue) {
            if (value === DEAL_WON) {
                setDealObject({ ...dealObject, status: null });
                setIsWonDealModalOpen(true);
                return;
            }

            setIsLoading(true);
            olanakDurumDegistir({
                id: selectedDeal.id,
                profil: dealProfileId,
                durum: selectedDeal.durum,
                lastStatus: selectedDeal.durum,
                kapanmaTarihi: selectedDeal.kapanmaTarihi,
                nationalIdNumber: selectedDealNationalIdNumber,
            })
                .then(() => {
                    setStatusValue(null);
                    setDealObject({ ...dealObject, status: null });
                })
                .finally(() => {
                    setIsLoading(false);
                });

            return;
        } else {
            if (value === DEAL_WON) {
                setDealObject({ ...dealObject, status: value, toBe: value });
                setState({ popupContent: POPUP_CONTENTS.NEW_DEAL, popupIsOpen: true });
            }

            if (value === DEAL_LOST || value === DEAL_CANCELLED) {
                if (value === DEAL_LOST && selectedDeal.durum === DEAL_WON) {
                    toast.warning("Won Deal status can be changed just to Cancelled");
                    return;
                }

                // A deal cannot be cancelled without a reason - ask for it before saving. This also
                // covers Won -> Cancelled, so the "remove as Won" confirmation is folded into this modal.
                if (value === DEAL_CANCELLED) {
                    setCancellation({ cancellationReason: "", cancellationNote: "" });
                    setIsCancellationModalOpen(true);
                    return;
                }

                setIsLoading(true);

                if (selectedDeal.durum === DEAL_WON) {
                    setIsWonDealModalOpen(true);
                    setDealObject({ ...dealObject, status: value });
                    return;
                }

                setDealObject({ ...dealObject, status: value });

                olanakDurumDegistir({
                    id: selectedDeal.id,
                    profil: dealProfileId,
                    durum: value,
                    lastStatus: selectedDeal.durum,
                    kapanmaTarihi: selectedDeal.kapanmaTarihi,
                    nationalIdNumber: selectedDealNationalIdNumber,
                }).finally(() => {
                    setIsLoading(false);
                });
            }
        }
    };

    const closeCancellationModal = () => {
        setIsCancellationModalOpen(false);
        setCancellation({ cancellationReason: "", cancellationNote: "" });
    };

    const handleCancelDeal = () => {
        const error = getCancellationReasonError(cancellationReasonsConfig, {
            dealCampaignType: selectedDeal?.dealCampaignType,
            ...cancellation,
        });
        if (error) {
            toast.warning(error);
            return;
        }

        setIsCancellationModalOpen(false);
        setIsLoading(true);
        setDealObject({ ...dealObject, status: DEAL_CANCELLED });
        olanakDurumDegistir({
            id: selectedDeal.id,
            profil: dealProfileId,
            durum: DEAL_CANCELLED,
            lastStatus: selectedDeal.durum,
            kapanmaTarihi: selectedDeal.kapanmaTarihi,
            nationalIdNumber: selectedDealNationalIdNumber,
            cancellationReason: cancellation.cancellationReason,
            cancellationNote: cancellation.cancellationNote.trim(),
        }).finally(() => {
            setIsLoading(false);
        });
    };

    const searchInputOptionClick = (id) => {
        window.open(`/extension?profileId=${id}`, "_blank");
    };
    const campaignCity = getDynamicValue(selectedDeal?.campaign?.columnsList, "City");
    const campaignCountry = getDynamicValue(selectedDeal?.campaign?.columnsList, "Country");

    const getCampaignCity = (city, country) => {
        const invalidValues = ["LVT", "LVT Public - Certified Programs", "LVT Public - Short Courses", "Online"];

        const isValid = city && country && !invalidValues.includes(city) && !invalidValues.includes(country);

        if (isValid) {
            return `| ${city}, ${country}`;
        }

        return "";
    };
    const cardItems = [
        {
            content: (
                <StyledContentWrapper>
                    <StyledLeftContent>
                        <Link to={`/accounts/details/${selectedDeal?.accountId}`} target="_blank">
                            <StyledDealTitle isLink={true} style={{ overflowWrap: "anywhere" }}>
                                {selectedDeal?.accountName ? selectedDeal.accountName : "No Account Name"}
                            </StyledDealTitle>
                        </Link>
                    </StyledLeftContent>
                    {wonDeals && wonDeals.wonDealCount > 0 && (
                        <DealLabelWrapper
                            onMouseEnter={() => setTooltipVisible(true)}
                            onMouseLeave={() => setTooltipVisible(false)}
                        >
                            <Label variant="success">
                                {wonDeals.wonDealCount + " " + (wonDeals.wonDealCount === 1 ? "Deal" : "Deals")}
                            </Label>
                            <ViewDealTooltip
                                onMouseEnter={() => setTooltipVisible(true)}
                                onMouseLeave={() => setTooltipVisible(false)}
                                style={{ display: tooltipVisible ? "block" : "none" }}
                            >
                                {wonDeals &&
                                    wonDeals?.profiles?.length > 0 &&
                                    wonDeals.profiles.map((result, index) => (
                                        <StyledResultItem key={index} onClick={() => searchInputOptionClick(result.id)}>
                                            {result.resim ? (
                                                <Avatar
                                                    src={result.resim}
                                                    alt={result.ad}
                                                    onError={(e) =>
                                                        (e.currentTarget.src = toAbsoluteUrl(
                                                            "/media/svg/icons/Extension/user-avatar.svg"
                                                        ))
                                                    }
                                                />
                                            ) : (
                                                <AvatarSvg
                                                    src={toAbsoluteUrl("/media/svg/icons/Extension/user-avatar.svg")}
                                                />
                                            )}
                                            <ResultText>
                                                <Name>
                                                    {result.ad} {result.soyad}
                                                </Name>
                                                <Info>
                                                    {result.sirket && result.sirket}
                                                    {result.sirket && result.baslik && " | "}
                                                    {result.baslik && result.baslik}
                                                </Info>
                                            </ResultText>
                                        </StyledResultItem>
                                    ))}
                            </ViewDealTooltip>
                        </DealLabelWrapper>
                    )}
                </StyledContentWrapper>
            ),
            imgSrc: selectedDeal?.accountLogoUrl ? selectedDeal?.accountLogoUrl : null,
            customImage: selectedDeal?.accountName ? (
                <StyledNameTag>{selectedDeal?.accountName.charAt(0) || ""}</StyledNameTag>
            ) : null,
        },
        selectedDeal?.campaign?.campaignTemplateCourseName && {
            content: <StyledDealTitle>{selectedDeal?.campaign?.campaignTemplateCourseName}</StyledDealTitle>,
            imgSrc: selectedDeal?.campaign?.imgURL || "",
            customImage: !selectedDeal?.campaign?.imgURL ? (
                <StyledNameTag>{nameTag(selectedDeal?.campaign?.campaignTemplateCourseName)}</StyledNameTag>
            ) : null,
        },
        selectedDeal?.campaign && {
            icon: (
                <div>
                    <FeatherIcon strokeWidth="2px" icon="thumbs-up" size="21" color={"#5f6367"} />
                </div>
            ),
            content: (
                <StyledContentWrapper>
                    <StyledLeftContent>
                        <a
                            href={
                                user?.company?.companyConfig?.oldCrmPopleadsHttpLink +
                                "/?campaignId=" +
                                selectedDeal?.campaign?.id
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <StyledDealTitle isLink={true}>{selectedDeal?.campaign?.ad}</StyledDealTitle>
                        </a>
                        <StyledDealContent>{`${selectedDeal?.campaign?.type} | ${
                            selectedDeal?.campaign?.campaignDate
                        }  ${getCampaignCity(campaignCity, campaignCountry)}`}</StyledDealContent>
                    </StyledLeftContent>
                </StyledContentWrapper>
            ),
        },
        {
            icon: <SVG src={toAbsoluteUrl("/media/svg/popleads/money_bag.svg")} />,
            content: (
                <StyledContentWrapper>
                    <StyledLeftContent style={{ gap: "4px" }}>
                        {courseNameLabel && (
                            <StyledDealContent>
                                {courseNameLabel}:{" "}
                                <b>{selectedDeal?.courseName || <FormattedMessage id="POPLEADS.NA" />}</b>
                            </StyledDealContent>
                        )}
                        <StyledDealContent>
                            Deal Campaign Type:{" "}
                            <b>{selectedDeal?.dealCampaignType || <FormattedMessage id="POPLEADS.NA" />}</b>
                        </StyledDealContent>
                        <StyledDealContent>
                            Deal Type: <b>{selectedDeal?.type || <FormattedMessage id="POPLEADS.NA" />}</b>
                        </StyledDealContent>
                        {isCipdCampaign(selectedDeal?.campaign) && (
                            <StyledDealContent>
                                Number of Installments:{" "}
                                <b>{selectedDeal?.numberOfInstallments || <FormattedMessage id="POPLEADS.NA" />}</b>
                            </StyledDealContent>
                        )}
                        {selectedDeal?.units > 1 && (
                            <StyledDealContent>
                                Number of Units: <b>{selectedDeal?.units || <FormattedMessage id="POPLEADS.NA" />}</b>
                            </StyledDealContent>
                        )}

                        {selectedDeal?.type === "Marketing" || selectedDeal?.type === "Marketing Cross Sale" ? (
                            <StyledDealContent>
                                Marketing Channel:{" "}
                                <b>{selectedDeal?.dealTypeChannel || <FormattedMessage id="POPLEADS.NA" />}</b>
                            </StyledDealContent>
                        ) : null}
                        {selectedDeal?.type === "Re-Seller Partnership" && (
                            <StyledDealContent>
                                End User:{" "}
                                <b style={{ overflowWrap: "anywhere" }}>
                                    {selectedDeal?.endUser || <FormattedMessage id="POPLEADS.NA" />}
                                </b>
                            </StyledDealContent>
                        )}
                    </StyledLeftContent>
                    <StyledPriceContent>
                        {selectedDeal?.totalAmount < 0 ||
                        selectedDeal?.totalAmount === 0 ||
                        selectedDeal?.totalAmount === "0"
                            ? "$ 0"
                            : selectedDeal.totalAmount > 0 && (
                                  <>
                                      $
                                      <FormattedNumber
                                          minimumFractionDigits={0}
                                          maximumFractionDigits={2}
                                          value={selectedDeal.totalAmount}
                                      />
                                  </>
                              )}
                    </StyledPriceContent>
                </StyledContentWrapper>
            ),
        },
        {
            icon: <SVG src={toAbsoluteUrl("/media/svg/popleads/inquiry.svg")} />,
            content: (
                <StyledContentWrapper>
                    <StyledLeftContent style={{ gap: "4px" }}>
                        <StyledDealContent>
                            Close Date:{" "}
                            <b>
                                {selectedDeal?.kapanmaTarihi ? (
                                    moment(selectedDeal?.kapanmaTarihi).format("MMM DD, YYYY")
                                ) : (
                                    <FormattedMessage id="POPLEADS.NA" />
                                )}
                            </b>
                        </StyledDealContent>
                        <StyledDealContent>
                            Partner: <b>{selectedDeal?.partnerName || <FormattedMessage id="POPLEADS.NA" />}</b>
                        </StyledDealContent>
                        <StyledDealContent>
                            Added By: <b>{selectedDeal?.ownerName || <FormattedMessage id="POPLEADS.NA" />}</b>
                        </StyledDealContent>
                    </StyledLeftContent>
                </StyledContentWrapper>
            ),
        },
        selectedDeal?.durum === DEAL_CANCELLED && {
            icon: <MaterialIcon icon="cancel" style={{ cursor: "default", opacity: 0.8, fontWeight: "300" }} />,
            content: (
                <StyledLeftContent style={{ gap: "4px" }}>
                    <StyledDealContent>
                        Cancellation Date:{" "}
                        <b>
                            {selectedDeal?.cancellationDate ? (
                                moment(selectedDeal.cancellationDate).format("MMM DD, YYYY")
                            ) : (
                                <FormattedMessage id="POPLEADS.NA" />
                            )}
                        </b>
                    </StyledDealContent>
                    <StyledDealContent>
                        Cancellation Reason:{" "}
                        <b>{selectedDeal?.cancellationReason || <FormattedMessage id="POPLEADS.NA" />}</b>
                    </StyledDealContent>
                    {selectedDeal?.cancellationNote && (
                        <StyledDealContent>
                            Cancellation Note:{" "}
                            <b style={{ overflowWrap: "anywhere" }}>{selectedDeal.cancellationNote}</b>
                        </StyledDealContent>
                    )}
                </StyledLeftContent>
            ),
        },
        (selectedDeal.durum === "Won" || selectedDeal?.attachmentList?.length > 0) && {
            icon: <MaterialIcon icon="attach_file" style={{ cursor: "default", opacity: 0.8, fontWeight: "300" }} />,
            content: (
                <ExtensionDealAttachments
                    maxFiles={5}
                    existingFiles={
                        selectedDeal?.attachmentList?.length > 0 ? [...selectedDeal.attachmentList].reverse() : []
                    }
                    size="sm"
                    isDisabled={selectedDeal.durum !== "Won"}
                    dealId={selectedDeal.id}
                />
            ),
        },
        // CIPD delegate information (Date of Birth, Physical Address, CV, National ID Number) -
        // Number of Installments is shown separately, right under Deal Type. One field per line,
        // only for deals of a CIPD campaign.
        isCipdCampaign(selectedDeal?.campaign) && {
            // MaterialIcon's "person" ligature isn't in the bundled material-symbols font
            // subset (renders as a missing-glyph box) - FeatherIcon's "user" is an SVG icon
            // from the same library already proven to render elsewhere in this file (the
            // "thumbs-up" icon above), so it doesn't carry that risk.
            icon: (
                <div>
                    <FeatherIcon strokeWidth="2px" icon="user" size="21" color={"#5f6367"} />
                </div>
            ),
            content: (
                <>
                    <StyledLeftContent style={{ gap: "4px" }}>
                        <StyledDealContent>
                            National ID Number:{" "}
                            <b>{selectedDeal?.nationalIdNumber || <FormattedMessage id="POPLEADS.NA" />}</b>
                        </StyledDealContent>
                        <StyledDealContent>
                            Membership: <b>{selectedDeal?.membership || <FormattedMessage id="POPLEADS.NA" />}</b>
                        </StyledDealContent>
                        <StyledDealContent>
                            Date of Birth:{" "}
                            <b>
                                {selectedDeal?.dateOfBirth ? (
                                    moment(selectedDeal.dateOfBirth).format("MMM DD, YYYY")
                                ) : (
                                    <FormattedMessage id="POPLEADS.NA" />
                                )}
                            </b>
                        </StyledDealContent>
                        <StyledDealContent>
                            Physical Address:{" "}
                            <b>{selectedDeal?.physicalAddress || <FormattedMessage id="POPLEADS.NA" />}</b>
                        </StyledDealContent>
                        <StyledDealContent>
                            CV:{" "}
                            <b>
                                {selectedDeal?.cvAttachment?.downloadLink ? (
                                    <a
                                        href={selectedDeal.cvAttachment.downloadLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: colors.l3rnTech[900], textDecoration: "underline" }}
                                    >
                                        {selectedDeal.cvAttachment.filename || "CV"}
                                    </a>
                                ) : (
                                    <FormattedMessage id="POPLEADS.NA" />
                                )}
                            </b>
                        </StyledDealContent>
                    </StyledLeftContent>
                </>
            ),
        },
    ].filter(Boolean);

    const DatePickerWrapper = styled.div`
        position: absolute;
        left: 23%;
        z-index: 10;
        background: ${colors.white};
        border-radius: 8px;
        box-shadow: 0px 2px 8px rgba(73, 105, 140, 0.1);
    `;

    /*useEffect(() => {
        if (selectedDeal) {
            setPotentialValue(parseInt(selectedDeal.lastStatus.replace("%", "")));
            setStatusValue(selectedDeal.durum);
        }
    }, [selectedDeal]);*/

    return (
        <StyledContainer>
            {isLoading && (
                <ProfileLoadingOverlay>
                    <Spinner size={32} thickness={4} variant="l3rnTech" />
                </ProfileLoadingOverlay>
            )}
            <ExtensionInputGroup
                variant="l3rnTech"
                label="Change the Deal Potential"
                type="range"
                options={{ min: 25, max: 75, step: 25 }}
                onChange={(value) => {
                    if (!isLoading) {
                        if (value !== potentialValue) {
                            if (selectedDeal.durum === DEAL_WON) {
                                setPotentialValue(value);
                                setIsWonDealModalOpen(true);
                                return;
                            }

                            setPotentialValue(value);
                            setStatusValue(null);
                            setDealObject({ ...dealObject, status: null });
                            setIsLoading(true);
                            olanakDurumDegistir({
                                id: selectedDeal.id,
                                profil: dealProfileId,
                                durum: value + "%",
                                lastStatus: selectedDeal.durum,
                                kapanmaTarihi: selectedDeal.kapanmaTarihi,
                                nationalIdNumber: selectedDealNationalIdNumber,
                            }).finally(() => {
                                setIsLoading(false);
                            });
                        }
                    }
                }}
                value={potentialValue}
                disabled={isLoading}
            />
            <div className="d-flex align-items-center justify-content-between">
                <StyledLabel>Status</StyledLabel>
                <div className="d-flex" style={{ gap: "8px" }}>
                    <Options
                        options={statusOptions}
                        selected={statusValue}
                        setSelected={(value) => handleStatusChange(value)}
                    />
                </div>
            </div>
            <Card iconWidth="40px" variant="only-hr" haveViewMore={false} cardItems={cardItems} />
            <ExtensionDealExEdCampaigns />
            <ExtensionActivities />
            <ExtensionDealPayment />

            <Modal
                isOpen={isClosingDateModalOpen}
                onClose={() => setIsClosingDateModalOpen(false)}
                title="The closing date is set to Today"
                variant="l3rnTech"
                icon="calendar_today"
                successButtonText="Change closing date"
                onSuccess={handleClosingDateClick}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    {showDatePicker && (
                        <DatePickerWrapper>
                            <CustomDatePicker
                                variant="move-dropdown"
                                onChange={handleDateChange}
                                onClickOutside={() => {
                                    setShowDatePicker(false);
                                }}
                            />
                        </DatePickerWrapper>
                    )}
                </div>
            </Modal>

            <Modal
                isOpen={isWonDealModalOpen}
                onClose={() => {
                    setPotentialValue(parseInt(selectedDeal?.lastStatus?.replace("%", "")) || 75);
                    setIsWonDealModalOpen(false);
                    setIsLoading(false);
                }}
                title="Are you sure you want to remove as Won this deal?"
                variant="l3rnTech"
                icon="warning"
                successButtonText="Yes"
                cancelButtonText="No"
                onSuccess={() => {
                    setIsWonDealModalOpen(false);
                    if (dealObject.status) {
                        // Status değişikliği durumu
                        olanakDurumDegistir({
                            id: selectedDeal.id,
                            profil: dealProfileId,
                            durum: dealObject.status,
                            lastStatus: selectedDeal.durum,
                            kapanmaTarihi: selectedDeal.kapanmaTarihi,
                            nationalIdNumber: selectedDealNationalIdNumber,
                        }).finally(() => {
                            setIsLoading(false);
                        });
                    } else {
                        // Deal potential değişikliği durumu
                        olanakDurumDegistir({
                            id: selectedDeal.id,
                            profil: dealProfileId,
                            durum: potentialValue + "%",
                            lastStatus: selectedDeal.durum,
                            kapanmaTarihi: selectedDeal.kapanmaTarihi,
                            nationalIdNumber: selectedDealNationalIdNumber,
                        }).finally(() => {
                            setIsLoading(false);
                            //toast.success("Status has been changed!");
                        });
                    }
                }}
                onCancel={() => {
                    setPotentialValue(parseInt(selectedDeal?.durum?.replace("%", "")) || 75);
                    setIsWonDealModalOpen(false);
                }}
            />

            <Modal
                isOpen={isCancellationModalOpen}
                onClose={closeCancellationModal}
                title={
                    selectedDeal?.durum === DEAL_WON
                        ? "Are you sure you want to cancel this Won deal?"
                        : "Why is this deal cancelled?"
                }
                variant="l3rnTech"
                icon="cancel"
                successButtonText="Cancel Deal"
                cancelButtonText="Back"
                onSuccess={handleCancelDeal}
            >
                <ExtensionCancellationReasonFields
                    dealCampaignType={selectedDeal?.dealCampaignType}
                    cancellationReason={cancellation.cancellationReason}
                    cancellationNote={cancellation.cancellationNote}
                    onChange={setCancellation}
                />
            </Modal>
        </StyledContainer>
    );
};

export default ExtensionViewDeal;
